import React, { PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import FirebaseAnalytics from '../core/analytics';
import { getDeviceType } from '../../utils/utils';
import { getTrialState } from '../../redux/selectors/selectors';
import { MarketingContainer } from './MarketingContainer';
import TopMenu from '../headers/top-menu';
import { RootState } from '../../bootstrap';
import css from '../../app.scss';

interface Props extends PropsWithChildren {
  permission: string | string[];
  fallback?: string;
  module?: string;
  permissions?: string[];
  withTrial?: boolean;
  withActiveTrial?: boolean;
}

const hasPermissions = (
  permission: string | string[],
  permissions?: string[],
  module?: string,
  withTrial?: boolean,
  withActiveTrial?: boolean,
) => {
  let result;
  const trialState = getTrialState();
  const { width, height } = window.screen;
  if (withTrial && trialState.isTrial) {
    return trialState.isTrial;
  }
  if (withActiveTrial && trialState.isTrial && !trialState.isExpired) {
    return true;
  }
  if (permissions && trialState.isTrial && trialState.isExpired) {
    return false;
  }
  if (typeof permission === 'string') {
    result = permissions?.includes(permission);
  } else {
    const intersection = permission.filter((value) => permissions.includes(value));
    result = intersection.length > 0;
  }
  if (!result && module) {
    FirebaseAnalytics.sendEvent(FirebaseAnalytics.EVENTS.PAGE_VIEW, module, FirebaseAnalytics.PAGES.HOME_PAGE, {
      resolution: `${width}X${height}`,
      browserType: getDeviceType(),
      permissions: permissions,
      hasPermission: false,
    });
  } else if (module) {
    FirebaseAnalytics.sendEvent(FirebaseAnalytics.EVENTS.PAGE_VIEW, module, FirebaseAnalytics.PAGES.HOME_PAGE, {
      resolution: `${width}X${height}`,
      browserType: getDeviceType(),
      hasPermission: true,
    });
  }
  return result;
};

export default function Permission({ permission, fallback, module, withTrial, withActiveTrial, children }: Props) {
  const permissions = useSelector((state: RootState) => state.app.permissions);

  if (hasPermissions(permission, permissions, module, withTrial, withActiveTrial)) {
    return <>{children}</>;
  } else if (fallback) {
    return (
      <>
        <div className={css.secondaryNavigation}>
          <TopMenu />
        </div>
        <MarketingContainer />
      </>
    );
  }

  return null;
}
